// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTime$dDuration$dSerialized from "../Data.Time.Duration.Serialized/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUTCTime from "../Data.UTCTime/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dCurrencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic$dGeocoding$dTypes$dDeliveryAddress from "../Restaumatic.Geocoding.Types.DeliveryAddress/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
import * as Restaumatic$dOrders$dPayments$dTypes$dPaymentError from "../Restaumatic.Orders.Payments.Types.PaymentError/index.js";
import * as Restaumatic$dOrders$dTypes$dDineInLocation from "../Restaumatic.Orders.Types.DineInLocation/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderDraft from "../Restaumatic.Orders.Types.OrderDraft/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderOrigin from "../Restaumatic.Orders.Types.OrderOrigin/index.js";
import * as Restaumatic$dOrders$dTypes$dPaymentMethod from "../Restaumatic.Orders.Types.PaymentMethod/index.js";
import * as Restaumatic$dOrders$dTypes$dTip from "../Restaumatic.Orders.Types.Tip/index.js";
import * as Restaumatic$dPromotions$dTypes$dPromotionalItem from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
import * as Restaumatic$dValidation$dTypes from "../Restaumatic.Validation.Types/index.js";
import * as Restaumatic$dVatId from "../Restaumatic.VatId/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $CheckoutError = (tag, _1) => ({tag, _1});
const $FulfillmentMethod = (tag, _1) => ({tag, _1});
const $ItemError = (tag, _1) => ({tag, _1});
const eq8 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") {
      if (x._1.tag === "Table") {
        if (y._1.tag === "Table") { return x._1._1.number === y._1._1.number; }
        return false;
      }
      if (x._1.tag === "ServingLocation") {
        if (y._1.tag === "ServingLocation") { return x._1._1.areaId === y._1._1.areaId && x._1._1.areaName === y._1._1.areaName && x._1._1.pointName === y._1._1.pointName; }
        return false;
      }
      return false;
    }
    return false;
  }
  return false;
};
const eq11 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq12 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Foreign$dInternal$dStringify.unsafeStringify(x._1) === Foreign$dInternal$dStringify.unsafeStringify(y._1); }
    return false;
  }
  return false;
};
const eq14 = /* #__PURE__ */ (() => {
  const $0 = Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString);
  return x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return $0.eq(x._1)(y._1); }
      return false;
    }
    return false;
  };
})();
const eq16 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.eqOrderOrigin.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq17 = /* #__PURE__ */ (() => {
  const $0 = Data$dEq.eqArrayImpl((() => {
    const $0 = Data$dEq.eqArrayImpl(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqContainedId.eq);
    return x => y => x._1 === y._1 && $0(x._2)(y._2);
  })());
  return x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return $0(x._1)(y._1); }
      return false;
    }
    return false;
  };
})();
const eq19 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dPromotions$dTypes$dPromotionalItem.eqPromotionalItem.eq))();
const eq20 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Data$dDateTime.eqDateTime.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const noteIsSymbol = {reflectSymbol: () => "note"};
const productKeyIsSymbol = {reflectSymbol: () => "productKey"};
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const ProductItemIsSymbol = {reflectSymbol: () => "ProductItem"};
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
const draftIsSymbol = {reflectSymbol: () => "draft"};
const itemsIsSymbol = {reflectSymbol: () => "items"};
const OrderSplitIsSymbol = {reflectSymbol: () => "OrderSplit"};
const MenuItemDisabledIsSymbol = {reflectSymbol: () => "MenuItemDisabled"};
const requestedQuantityIsSymbol = {reflectSymbol: () => "requestedQuantity"};
const InvalidQuantityIsSymbol = {reflectSymbol: () => "InvalidQuantity"};
const CustomProductsNotAvailableIsSymbol = {reflectSymbol: () => "CustomProductsNotAvailable"};
const FatalErrorIsSymbol = {reflectSymbol: () => "FatalError"};
const SoftErrorIsSymbol = {reflectSymbol: () => "SoftError"};
const customDeliveryPriceIsSymbol = {reflectSymbol: () => "customDeliveryPrice"};
const deliveryAddressIsSymbol = {reflectSymbol: () => "deliveryAddress"};
const DeliveryIsSymbol = {reflectSymbol: () => "Delivery"};
const TakeawayIsSymbol = {reflectSymbol: () => "Takeaway"};
const locationIsSymbol = {reflectSymbol: () => "location"};
const DineInIsSymbol = {reflectSymbol: () => "DineIn"};
const NoContactDeliveryIsSymbol = {reflectSymbol: () => "NoContactDelivery"};
const decodeRecordCons1 = /* #__PURE__ */ Unscramble.decodeRecordCons(deliveryAddressIsSymbol)(Restaumatic$dGeocoding$dTypes$dDeliveryAddress.unscrambleDecodeDeliveryAddress)(Unscramble.decodeRecordNil);
const emailIsSymbol = {reflectSymbol: () => "email"};
const fullNameIsSymbol = {reflectSymbol: () => "fullName"};
const phoneIsSymbol = {reflectSymbol: () => "phone"};
const subscribeEmailIsSymbol = {reflectSymbol: () => "subscribeEmail"};
const subscribePhoneIsSymbol = {reflectSymbol: () => "subscribePhone"};
const subscribeRestaumaticEmailIsSymbol = {reflectSymbol: () => "subscribeRestaumaticEmail"};
const subscribeRestaumaticPhoneIsSymbol = {reflectSymbol: () => "subscribeRestaumaticPhone"};
const subscribedIsSymbol = {reflectSymbol: () => "subscribed"};
const subscribedRestaumaticIsSymbol = {reflectSymbol: () => "subscribedRestaumatic"};
const CustomerIsSymbol = {reflectSymbol: () => "Customer"};
const decodeMaybe1 = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeBoolean1);
const couponCodesIsSymbol = {reflectSymbol: () => "couponCodes"};
const customerIsSymbol = {reflectSymbol: () => "customer"};
const extraDiscountIsSymbol = {reflectSymbol: () => "extraDiscount"};
const fieldTestExperimentsIsSymbol = {reflectSymbol: () => "fieldTestExperiments"};
const fulfillmentMethodIsSymbol = {reflectSymbol: () => "fulfillmentMethod"};
const isIosReviewModeIsSymbol = {reflectSymbol: () => "isIosReviewMode"};
const localeIsSymbol = {reflectSymbol: () => "locale"};
const originIsSymbol = {reflectSymbol: () => "origin"};
const packagingContainersIsSymbol = {reflectSymbol: () => "packagingContainers"};
const paymentMethodIsSymbol = {reflectSymbol: () => "paymentMethod"};
const promotionalItemsIsSymbol = {reflectSymbol: () => "promotionalItems"};
const requestedFulfillmentTimeIsSymbol = {reflectSymbol: () => "requestedFulfillmentTime"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const tipIsSymbol = {reflectSymbol: () => "tip"};
const userNoteIsSymbol = {reflectSymbol: () => "userNote"};
const vatIdIsSymbol = {reflectSymbol: () => "vatId"};
const waiterPinIsSymbol = {reflectSymbol: () => "waiterPin"};
const CheckoutRequestIsSymbol = {reflectSymbol: () => "CheckoutRequest"};
const RestaurantDoesNotExistIsSymbol = {reflectSymbol: () => "RestaurantDoesNotExist"};
const AccountDoesNotExistIsSymbol = {reflectSymbol: () => "AccountDoesNotExist"};
const InvalidUserInSessionIsSymbol = {reflectSymbol: () => "InvalidUserInSession"};
const OrderDoesNotExistIsSymbol = {reflectSymbol: () => "OrderDoesNotExist"};
const OrderNotEditableIsSymbol = {reflectSymbol: () => "OrderNotEditable"};
const RegisteredUserShouldLogInIsSymbol = {reflectSymbol: () => "RegisteredUserShouldLogIn"};
const EmailNotProvidedAndNotLoggedInIsSymbol = {reflectSymbol: () => "EmailNotProvidedAndNotLoggedIn"};
const InvalidEmailIsSymbol = {reflectSymbol: () => "InvalidEmail"};
const InvalidPhoneNumberIsSymbol = {reflectSymbol: () => "InvalidPhoneNumber"};
const QrWaiterDisabledIsSymbol = {reflectSymbol: () => "QrWaiterDisabled"};
const FulfillmentMethodNotSupportedIsSymbol = {reflectSymbol: () => "FulfillmentMethodNotSupported"};
const PaymentMethodNotSupportedIsSymbol = {reflectSymbol: () => "PaymentMethodNotSupported"};
const TipsNotAllowedIsSymbol = {reflectSymbol: () => "TipsNotAllowed"};
const NegativeTipIsSymbol = {reflectSymbol: () => "NegativeTip"};
const InvalidVatIdIsSymbol = {reflectSymbol: () => "InvalidVatId"};
const LocaleNotEnabledIsSymbol = {reflectSymbol: () => "LocaleNotEnabled"};
const NotInDeliveryAreaIsSymbol = {reflectSymbol: () => "NotInDeliveryArea"};
const CoordinatesNotProvidedIsSymbol = {reflectSymbol: () => "CoordinatesNotProvided"};
const actualValueIsSymbol = {reflectSymbol: () => "actualValue"};
const currencyIsSymbol = {reflectSymbol: () => "currency"};
const limitIsSymbol = {reflectSymbol: () => "limit"};
const genericShowConstructor1 = /* #__PURE__ */ Data$dShow$dGeneric.genericShowConstructor({
  genericShowArgs: v => [
    "{ actualValue: " + Data$dMoney$dRounded.toString(v.actualValue) + ", currency: " + Restaumatic$dCurrencies.showCurrency.show(v.currency) + ", limit: " + Data$dMoney$dRounded.toString(v.limit) + " " + "}"
  ]
});
const OrderValueTooLowIsSymbol = {reflectSymbol: () => "OrderValueTooLow"};
const OrderValueTooHighIsSymbol = {reflectSymbol: () => "OrderValueTooHigh"};
const DelayedDeliveryNotEnabledIsSymbol = {reflectSymbol: () => "DelayedDeliveryNotEnabled"};
const differenceIsSymbol = {reflectSymbol: () => "difference"};
const RequestedDeliveryTimeTooShortIsSymbol = {reflectSymbol: () => "RequestedDeliveryTimeTooShort"};
const OutsideOfOrderingHoursIsSymbol = {reflectSymbol: () => "OutsideOfOrderingHours"};
const DelayedDeliveryOutsideOfOrderingHoursIsSymbol = {reflectSymbol: () => "DelayedDeliveryOutsideOfOrderingHours"};
const PromotionValidationErrorsIsSymbol = {reflectSymbol: () => "PromotionValidationErrors"};
const InvalidCouponIsSymbol = {reflectSymbol: () => "InvalidCoupon"};
const groupIndexIsSymbol = {reflectSymbol: () => "groupIndex"};
const itemErrorIsSymbol = {reflectSymbol: () => "itemError"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const ItemErrorIsSymbol = {reflectSymbol: () => "ItemError"};
const FodAlreadyOrderedToAddressIsSymbol = {reflectSymbol: () => "FodAlreadyOrderedToAddress"};
const ExtraDiscountNotAllowedIsSymbol = {reflectSymbol: () => "ExtraDiscountNotAllowed"};
const ForbiddenOriginIsSymbol = {reflectSymbol: () => "ForbiddenOrigin"};
const OriginNotProvidedIsSymbol = {reflectSymbol: () => "OriginNotProvided"};
const PaymentErrorIsSymbol = {reflectSymbol: () => "PaymentError"};
const InvalidPackagingAssignmentIsSymbol = {reflectSymbol: () => "InvalidPackagingAssignment"};
const SmsVerificationRequiredIsSymbol = {reflectSymbol: () => "SmsVerificationRequired"};
const decodeSingleConstructorAr1 = /* #__PURE__ */ (() => (
  {
    unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(actualValueIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(currencyIsSymbol)(Restaumatic$dCurrencies.unscrambleDecodeCurrency)(Unscramble.decodeRecordCons(limitIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther1 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const encodeRecordCons2 = /* #__PURE__ */ Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(deliveryAddressIsSymbol)({
  encodeWithOptions: v => Restaumatic$dGeocoding$dTypes$dDeliveryAddress.encodeDeliveryAddress.encode
});
const encodeWithOptionsOther2 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const encodeWithOptionsOther3 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther4 = {encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode};
const genericEncodeArgsRecord = /* #__PURE__ */ (() => {
  const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(limitIsSymbol)(encodeWithOptionsOther4))(currencyIsSymbol)({
    encodeWithOptions: v => Restaumatic$dCurrencies.encodeCurrency.encode
  }))(actualValueIsSymbol)(encodeWithOptionsOther4);
  return {
    encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)), Data$dList$dTypes.Nil)
  };
})();
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const decodeRecordCons4 = /* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(deliveryAddressIsSymbol)({
  decodeWithOptions: v => Restaumatic$dGeocoding$dTypes$dDeliveryAddress.decodeDeliveryAddress.decode
})();
const decodeWithOptionsOther2 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.booleanDecode.decode)};
const decodeWithOptionsOther3 = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const decodeWithOptionsOther4 = {decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode};
const genericDecodeArgsRecord = /* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(limitIsSymbol)(decodeWithOptionsOther4)())(currencyIsSymbol)({
  decodeWithOptions: v => Restaumatic$dCurrencies.decodeCurrency.decode
})())(actualValueIsSymbol)(decodeWithOptionsOther4)()));
const ProductItem = x => x;
const OrderSplit = x => x;
const MenuItemDisabled = /* #__PURE__ */ $ItemError("MenuItemDisabled");
const InvalidQuantity = value0 => $ItemError("InvalidQuantity", value0);
const CustomProductsNotAvailable = /* #__PURE__ */ $ItemError("CustomProductsNotAvailable");
const FatalError = value0 => $ItemError("FatalError", value0);
const SoftError = value0 => $ItemError("SoftError", value0);
const Delivery = value0 => $FulfillmentMethod("Delivery", value0);
const Takeaway = /* #__PURE__ */ $FulfillmentMethod("Takeaway");
const DineIn = value0 => $FulfillmentMethod("DineIn", value0);
const NoContactDelivery = value0 => $FulfillmentMethod("NoContactDelivery", value0);
const Customer = x => x;
const CheckoutRequest = x => x;
const RestaurantDoesNotExist = /* #__PURE__ */ $CheckoutError("RestaurantDoesNotExist");
const AccountDoesNotExist = /* #__PURE__ */ $CheckoutError("AccountDoesNotExist");
const InvalidUserInSession = /* #__PURE__ */ $CheckoutError("InvalidUserInSession");
const OrderDoesNotExist = /* #__PURE__ */ $CheckoutError("OrderDoesNotExist");
const OrderNotEditable = /* #__PURE__ */ $CheckoutError("OrderNotEditable");
const RegisteredUserShouldLogIn = /* #__PURE__ */ $CheckoutError("RegisteredUserShouldLogIn");
const EmailNotProvidedAndNotLoggedIn = /* #__PURE__ */ $CheckoutError("EmailNotProvidedAndNotLoggedIn");
const InvalidEmail = /* #__PURE__ */ $CheckoutError("InvalidEmail");
const InvalidPhoneNumber = /* #__PURE__ */ $CheckoutError("InvalidPhoneNumber");
const QrWaiterDisabled = /* #__PURE__ */ $CheckoutError("QrWaiterDisabled");
const FulfillmentMethodNotSupported = /* #__PURE__ */ $CheckoutError("FulfillmentMethodNotSupported");
const PaymentMethodNotSupported = /* #__PURE__ */ $CheckoutError("PaymentMethodNotSupported");
const TipsNotAllowed = /* #__PURE__ */ $CheckoutError("TipsNotAllowed");
const NegativeTip = /* #__PURE__ */ $CheckoutError("NegativeTip");
const InvalidVatId = /* #__PURE__ */ $CheckoutError("InvalidVatId");
const LocaleNotEnabled = /* #__PURE__ */ $CheckoutError("LocaleNotEnabled");
const NotInDeliveryArea = /* #__PURE__ */ $CheckoutError("NotInDeliveryArea");
const CoordinatesNotProvided = /* #__PURE__ */ $CheckoutError("CoordinatesNotProvided");
const OrderValueTooLow = value0 => $CheckoutError("OrderValueTooLow", value0);
const OrderValueTooHigh = value0 => $CheckoutError("OrderValueTooHigh", value0);
const DelayedDeliveryNotEnabled = /* #__PURE__ */ $CheckoutError("DelayedDeliveryNotEnabled");
const RequestedDeliveryTimeTooShort = value0 => $CheckoutError("RequestedDeliveryTimeTooShort", value0);
const OutsideOfOrderingHours = /* #__PURE__ */ $CheckoutError("OutsideOfOrderingHours");
const DelayedDeliveryOutsideOfOrderingHours = /* #__PURE__ */ $CheckoutError("DelayedDeliveryOutsideOfOrderingHours");
const PromotionValidationErrors = value0 => $CheckoutError("PromotionValidationErrors", value0);
const InvalidCoupon = /* #__PURE__ */ $CheckoutError("InvalidCoupon");
const ItemError = value0 => $CheckoutError("ItemError", value0);
const FodAlreadyOrderedToAddress = /* #__PURE__ */ $CheckoutError("FodAlreadyOrderedToAddress");
const ExtraDiscountNotAllowed = /* #__PURE__ */ $CheckoutError("ExtraDiscountNotAllowed");
const ForbiddenOrigin = /* #__PURE__ */ $CheckoutError("ForbiddenOrigin");
const OriginNotProvided = /* #__PURE__ */ $CheckoutError("OriginNotProvided");
const PaymentError = value0 => $CheckoutError("PaymentError", value0);
const InvalidPackagingAssignment = /* #__PURE__ */ $CheckoutError("InvalidPackagingAssignment");
const SmsVerificationRequired = /* #__PURE__ */ $CheckoutError("SmsVerificationRequired");
const toFillFormTypeProductItem = {fillFormDataType: v => "unknown"};
const toFillFormTypeOrderSplit = {fillFormDataType: v => "unknown"};
const toFillFormTypeItemError = {fillFormDataType: v => "unknown"};
const toFillFormTypeFulfillment = {fillFormDataType: v => "unknown"};
const toFillFormTypeCustomer = {fillFormDataType: v => "unknown"};
const toFillFormTypeCheckoutReq = {fillFormDataType: v => "unknown"};
const toFillFormTypeCheckoutErr = {fillFormDataType: v => "unknown"};
const newtypeProductItem_ = {Coercible0: () => {}};
const newtypeOrderSplit_ = {Coercible0: () => {}};
const newtypeCustomer_ = {Coercible0: () => {}};
const newtypeCheckoutRequest_ = {Coercible0: () => {}};
const hasFieldProductItem = dictHasField => dictHasField;
const hasFieldOrderSplit = dictHasField => dictHasField;
const hasFieldCustomer = dictHasField => dictHasField;
const hasFieldCheckoutRequest = dictHasField => dictHasField;
const eqProductItem = {
  eq: x => y => (() => {
    if (x.note.tag === "Nothing") { return y.note.tag === "Nothing"; }
    if (x.note.tag === "Just") {
      if (y.note.tag === "Just") { return x.note._1 === y.note._1; }
      return false;
    }
    return false;
  })() && Restaumatic$dCart$dProductKey.eqProductKey.eq(x.productKey)(y.productKey) && x.quantity === y.quantity
};
const eq30 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqProductItem.eq))();
const eqOrderSplit = {eq: x => y => Foreign$dInternal$dStringify.unsafeStringify(x.draft) === Foreign$dInternal$dStringify.unsafeStringify(y.draft) && eq30(x.items)(y.items)};
const eqItemError = {
  eq: x => y => {
    if (x.tag === "MenuItemDisabled") { return y.tag === "MenuItemDisabled"; }
    if (x.tag === "InvalidQuantity") {
      if (y.tag === "InvalidQuantity") { return x._1.requestedQuantity === y._1.requestedQuantity; }
      return false;
    }
    if (x.tag === "CustomProductsNotAvailable") { return y.tag === "CustomProductsNotAvailable"; }
    if (x.tag === "FatalError") {
      if (y.tag === "FatalError") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.eqFatalError.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "SoftError") {
      if (y.tag === "SoftError") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.eqSoftError.eq(x._1)(y._1); }
      return false;
    }
    return false;
  }
};
const eqFulfillmentMethod = {
  eq: x => y => {
    if (x.tag === "Delivery") {
      if (y.tag === "Delivery") {
        return (() => {
          if (x._1.customDeliveryPrice.tag === "Nothing") { return y._1.customDeliveryPrice.tag === "Nothing"; }
          if (x._1.customDeliveryPrice.tag === "Just") {
            if (y._1.customDeliveryPrice.tag === "Just") { return x._1.customDeliveryPrice._1 === y._1.customDeliveryPrice._1; }
            return false;
          }
          return false;
        })() && Restaumatic$dGeocoding$dTypes$dDeliveryAddress.eqDeliveryAddress.eq(x._1.deliveryAddress)(y._1.deliveryAddress);
      }
      return false;
    }
    if (x.tag === "Takeaway") { return y.tag === "Takeaway"; }
    if (x.tag === "DineIn") {
      if (y.tag === "DineIn") { return eq8(x._1.location)(y._1.location); }
      return false;
    }
    if (x.tag === "NoContactDelivery") {
      if (y.tag === "NoContactDelivery") { return Restaumatic$dGeocoding$dTypes$dDeliveryAddress.eqDeliveryAddress.eq(x._1.deliveryAddress)(y._1.deliveryAddress); }
      return false;
    }
    return false;
  }
};
const eqCustomer = {
  eq: x => y => (() => {
    if (x.email.tag === "Nothing") { return y.email.tag === "Nothing"; }
    if (x.email.tag === "Just") {
      if (y.email.tag === "Just") { return x.email._1 === y.email._1; }
      return false;
    }
    return false;
  })() && x.fullName === y.fullName && (() => {
    if (x.phone.tag === "Nothing") { return y.phone.tag === "Nothing"; }
    if (x.phone.tag === "Just") {
      if (y.phone.tag === "Just") { return x.phone._1 === y.phone._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribeEmail.tag === "Nothing") { return y.subscribeEmail.tag === "Nothing"; }
    if (x.subscribeEmail.tag === "Just") {
      if (y.subscribeEmail.tag === "Just") { return x.subscribeEmail._1 === y.subscribeEmail._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribePhone.tag === "Nothing") { return y.subscribePhone.tag === "Nothing"; }
    if (x.subscribePhone.tag === "Just") {
      if (y.subscribePhone.tag === "Just") { return x.subscribePhone._1 === y.subscribePhone._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribeRestaumaticEmail.tag === "Nothing") { return y.subscribeRestaumaticEmail.tag === "Nothing"; }
    if (x.subscribeRestaumaticEmail.tag === "Just") {
      if (y.subscribeRestaumaticEmail.tag === "Just") { return x.subscribeRestaumaticEmail._1 === y.subscribeRestaumaticEmail._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribeRestaumaticPhone.tag === "Nothing") { return y.subscribeRestaumaticPhone.tag === "Nothing"; }
    if (x.subscribeRestaumaticPhone.tag === "Just") {
      if (y.subscribeRestaumaticPhone.tag === "Just") { return x.subscribeRestaumaticPhone._1 === y.subscribeRestaumaticPhone._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribed.tag === "Nothing") { return y.subscribed.tag === "Nothing"; }
    if (x.subscribed.tag === "Just") {
      if (y.subscribed.tag === "Just") { return x.subscribed._1 === y.subscribed._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.subscribedRestaumatic.tag === "Nothing") { return y.subscribedRestaumatic.tag === "Nothing"; }
    if (x.subscribedRestaumatic.tag === "Just") {
      if (y.subscribedRestaumatic.tag === "Just") { return x.subscribedRestaumatic._1 === y.subscribedRestaumatic._1; }
      return false;
    }
    return false;
  })()
};
const eqCheckoutRequest = {
  eq: x => y => eq11(x.couponCodes)(y.couponCodes) && eqCustomer.eq(x.customer)(y.customer) && eq12(x.draft)(y.draft) && (() => {
    if (x.extraDiscount.tag === "Nothing") { return y.extraDiscount.tag === "Nothing"; }
    if (x.extraDiscount.tag === "Just") {
      if (y.extraDiscount.tag === "Just") {
        return x.extraDiscount._1.name === y.extraDiscount._1.name && (() => {
          if (x.extraDiscount._1.prize.tag === "PriceDiscount") {
            if (y.extraDiscount._1.prize.tag === "PriceDiscount") { return x.extraDiscount._1.prize._1 === y.extraDiscount._1.prize._1; }
            return false;
          }
          if (x.extraDiscount._1.prize.tag === "PercentageDiscount") {
            if (y.extraDiscount._1.prize.tag === "PercentageDiscount") { return x.extraDiscount._1.prize._1 === y.extraDiscount._1.prize._1; }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    return false;
  })() && eq14(x.fieldTestExperiments)(y.fieldTestExperiments) && eqFulfillmentMethod.eq(x.fulfillmentMethod)(y.fulfillmentMethod) && (() => {
    if (x.isIosReviewMode.tag === "Nothing") { return y.isIosReviewMode.tag === "Nothing"; }
    if (x.isIosReviewMode.tag === "Just") {
      if (y.isIosReviewMode.tag === "Just") { return x.isIosReviewMode._1 === y.isIosReviewMode._1; }
      return false;
    }
    return false;
  })() && eq30(x.items)(y.items) && (() => {
    if (x.locale.tag === "PL") { return y.locale.tag === "PL"; }
    if (x.locale.tag === "EN") { return y.locale.tag === "EN"; }
    if (x.locale.tag === "EN_GB") { return y.locale.tag === "EN_GB"; }
    if (x.locale.tag === "RO") { return y.locale.tag === "RO"; }
    if (x.locale.tag === "RU") { return y.locale.tag === "RU"; }
    if (x.locale.tag === "CS") { return y.locale.tag === "CS"; }
    if (x.locale.tag === "SK") { return y.locale.tag === "SK"; }
    if (x.locale.tag === "HR") { return y.locale.tag === "HR"; }
    if (x.locale.tag === "DE") { return y.locale.tag === "DE"; }
    if (x.locale.tag === "NL") { return y.locale.tag === "NL"; }
    if (x.locale.tag === "ES") { return y.locale.tag === "ES"; }
    if (x.locale.tag === "IT") { return y.locale.tag === "IT"; }
    if (x.locale.tag === "UK") { return y.locale.tag === "UK"; }
    if (x.locale.tag === "SL") { return y.locale.tag === "SL"; }
    if (x.locale.tag === "PT_BR") { return y.locale.tag === "PT_BR"; }
    return false;
  })() && eq16(x.origin)(y.origin) && eq17(x.packagingContainers)(y.packagingContainers) && (() => {
    if (x.paymentMethod.tag === "Cash") { return y.paymentMethod.tag === "Cash"; }
    if (x.paymentMethod.tag === "Online") { return y.paymentMethod.tag === "Online"; }
    if (x.paymentMethod.tag === "Card") { return y.paymentMethod.tag === "Card"; }
    if (x.paymentMethod.tag === "Prepaid") { return y.paymentMethod.tag === "Prepaid"; }
    if (x.paymentMethod.tag === "Offline") { return y.paymentMethod.tag === "Offline"; }
    if (x.paymentMethod.tag === "CashAndCard") { return y.paymentMethod.tag === "CashAndCard"; }
    if (x.paymentMethod.tag === "BankTransfer") { return y.paymentMethod.tag === "BankTransfer"; }
    return false;
  })() && eq19(x.promotionalItems)(y.promotionalItems) && eq20(x.requestedFulfillmentTime)(y.requestedFulfillmentTime) && x.restaurantId === y.restaurantId && (() => {
    if (x.tip.tag === "Nothing") { return y.tip.tag === "Nothing"; }
    if (x.tip.tag === "Just") {
      if (y.tip.tag === "Just") { return x.tip._1._1 === y.tip._1._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.userNote.tag === "Nothing") { return y.userNote.tag === "Nothing"; }
    if (x.userNote.tag === "Just") {
      if (y.userNote.tag === "Just") { return x.userNote._1 === y.userNote._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.vatId.tag === "Nothing") { return y.vatId.tag === "Nothing"; }
    if (x.vatId.tag === "Just") {
      if (y.vatId.tag === "Just") { return x.vatId._1 === y.vatId._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.waiterPin.tag === "Nothing") { return y.waiterPin.tag === "Nothing"; }
    if (x.waiterPin.tag === "Just") {
      if (y.waiterPin.tag === "Just") { return x.waiterPin._1 === y.waiterPin._1; }
      return false;
    }
    return false;
  })()
};
const eqCheckoutError = {
  eq: x => y => {
    if (x.tag === "RestaurantDoesNotExist") { return y.tag === "RestaurantDoesNotExist"; }
    if (x.tag === "AccountDoesNotExist") { return y.tag === "AccountDoesNotExist"; }
    if (x.tag === "InvalidUserInSession") { return y.tag === "InvalidUserInSession"; }
    if (x.tag === "OrderDoesNotExist") { return y.tag === "OrderDoesNotExist"; }
    if (x.tag === "OrderNotEditable") { return y.tag === "OrderNotEditable"; }
    if (x.tag === "RegisteredUserShouldLogIn") { return y.tag === "RegisteredUserShouldLogIn"; }
    if (x.tag === "EmailNotProvidedAndNotLoggedIn") { return y.tag === "EmailNotProvidedAndNotLoggedIn"; }
    if (x.tag === "InvalidEmail") { return y.tag === "InvalidEmail"; }
    if (x.tag === "InvalidPhoneNumber") { return y.tag === "InvalidPhoneNumber"; }
    if (x.tag === "QrWaiterDisabled") { return y.tag === "QrWaiterDisabled"; }
    if (x.tag === "FulfillmentMethodNotSupported") { return y.tag === "FulfillmentMethodNotSupported"; }
    if (x.tag === "PaymentMethodNotSupported") { return y.tag === "PaymentMethodNotSupported"; }
    if (x.tag === "TipsNotAllowed") { return y.tag === "TipsNotAllowed"; }
    if (x.tag === "NegativeTip") { return y.tag === "NegativeTip"; }
    if (x.tag === "InvalidVatId") { return y.tag === "InvalidVatId"; }
    if (x.tag === "LocaleNotEnabled") { return y.tag === "LocaleNotEnabled"; }
    if (x.tag === "NotInDeliveryArea") { return y.tag === "NotInDeliveryArea"; }
    if (x.tag === "CoordinatesNotProvided") { return y.tag === "CoordinatesNotProvided"; }
    if (x.tag === "OrderValueTooLow") {
      if (y.tag === "OrderValueTooLow") {
        return x._1.actualValue === y._1.actualValue && (() => {
          if (x._1.currency.tag === "PLN") { return y._1.currency.tag === "PLN"; }
          if (x._1.currency.tag === "GBP") { return y._1.currency.tag === "GBP"; }
          if (x._1.currency.tag === "USD") { return y._1.currency.tag === "USD"; }
          if (x._1.currency.tag === "EUR") { return y._1.currency.tag === "EUR"; }
          if (x._1.currency.tag === "RUB") { return y._1.currency.tag === "RUB"; }
          if (x._1.currency.tag === "RON") { return y._1.currency.tag === "RON"; }
          if (x._1.currency.tag === "CZK") { return y._1.currency.tag === "CZK"; }
          if (x._1.currency.tag === "HRK") { return y._1.currency.tag === "HRK"; }
          if (x._1.currency.tag === "BRL") { return y._1.currency.tag === "BRL"; }
          return false;
        })() && x._1.limit === y._1.limit;
      }
      return false;
    }
    if (x.tag === "OrderValueTooHigh") {
      if (y.tag === "OrderValueTooHigh") {
        return x._1.actualValue === y._1.actualValue && (() => {
          if (x._1.currency.tag === "PLN") { return y._1.currency.tag === "PLN"; }
          if (x._1.currency.tag === "GBP") { return y._1.currency.tag === "GBP"; }
          if (x._1.currency.tag === "USD") { return y._1.currency.tag === "USD"; }
          if (x._1.currency.tag === "EUR") { return y._1.currency.tag === "EUR"; }
          if (x._1.currency.tag === "RUB") { return y._1.currency.tag === "RUB"; }
          if (x._1.currency.tag === "RON") { return y._1.currency.tag === "RON"; }
          if (x._1.currency.tag === "CZK") { return y._1.currency.tag === "CZK"; }
          if (x._1.currency.tag === "HRK") { return y._1.currency.tag === "HRK"; }
          if (x._1.currency.tag === "BRL") { return y._1.currency.tag === "BRL"; }
          return false;
        })() && x._1.limit === y._1.limit;
      }
      return false;
    }
    if (x.tag === "DelayedDeliveryNotEnabled") { return y.tag === "DelayedDeliveryNotEnabled"; }
    if (x.tag === "RequestedDeliveryTimeTooShort") {
      if (y.tag === "RequestedDeliveryTimeTooShort") { return x._1.difference === y._1.difference; }
      return false;
    }
    if (x.tag === "OutsideOfOrderingHours") { return y.tag === "OutsideOfOrderingHours"; }
    if (x.tag === "DelayedDeliveryOutsideOfOrderingHours") { return y.tag === "DelayedDeliveryOutsideOfOrderingHours"; }
    if (x.tag === "PromotionValidationErrors") {
      if (y.tag === "PromotionValidationErrors") { return Restaumatic$dValidation$dTypes.eq2(x._1)(y._1); }
      return false;
    }
    if (x.tag === "InvalidCoupon") { return y.tag === "InvalidCoupon"; }
    if (x.tag === "ItemError") {
      if (y.tag === "ItemError") {
        return x._1.groupIndex === y._1.groupIndex && eqItemError.eq(x._1.itemError)(y._1.itemError) && (() => {
          if (x._1.name.tag === "Nothing") { return y._1.name.tag === "Nothing"; }
          if (x._1.name.tag === "Just") {
            if (y._1.name.tag === "Just") { return x._1.name._1 === y._1.name._1; }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "FodAlreadyOrderedToAddress") { return y.tag === "FodAlreadyOrderedToAddress"; }
    if (x.tag === "ExtraDiscountNotAllowed") { return y.tag === "ExtraDiscountNotAllowed"; }
    if (x.tag === "ForbiddenOrigin") { return y.tag === "ForbiddenOrigin"; }
    if (x.tag === "OriginNotProvided") { return y.tag === "OriginNotProvided"; }
    if (x.tag === "PaymentError") {
      if (y.tag === "PaymentError") {
        if (x._1.tag === "InvalidBlikCode") { return y._1.tag === "InvalidBlikCode"; }
        if (x._1.tag === "CardProcessingError") { return y._1.tag === "CardProcessingError"; }
        if (x._1.tag === "OtherError") {
          if (y._1.tag === "OtherError") { return x._1._1 === y._1._1; }
          return false;
        }
        return false;
      }
      return false;
    }
    if (x.tag === "InvalidPackagingAssignment") { return y.tag === "InvalidPackagingAssignment"; }
    if (x.tag === "SmsVerificationRequired") { return y.tag === "SmsVerificationRequired"; }
    return false;
  }
};
const genericProductItem = {to: x => x, from: x => x};
const showProductItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ note: " + showMaybe.show(v.note) + ", productKey: " + Restaumatic$dCart$dProductKey.showProductKey.show(v.productKey) + ", quantity: " + Data$dShow.showIntImpl(v.quantity) + " " + "}"
      ]
    })(ProductItemIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showArray = /* #__PURE__ */ (() => ({show: Data$dShow.showArrayImpl(showProductItem.show)}))();
const unscrambleDecodeProductItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(noteIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(productKeyIsSymbol)(Restaumatic$dCart$dProductKey.unscrambleDecodeProductKey)(Unscramble.decodeRecordCons(quantityIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const decodeRecordCons5 = /* #__PURE__ */ (() => Unscramble.decodeRecordCons(itemsIsSymbol)({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeProductItem.unsafeDecode)}))();
const genericOrderSplit = {to: x => x, from: x => x};
const showOrderSplit = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ draft: " + Restaumatic$dOrders$dTypes$dOrderDraft.showOrderDraft.show(v.draft) + ", items: " + showArray.show(v.items) + " " + "}"]
    })(OrderSplitIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeOrderSplit = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(draftIsSymbol)(Restaumatic$dOrders$dTypes$dOrderDraft.unscrambleDecodeOrderDraft)(decodeRecordCons5(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericItemError = {
  to: x => {
    if (x.tag === "Inl") { return MenuItemDisabled; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ItemError("InvalidQuantity", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return CustomProductsNotAvailable; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return $ItemError("FatalError", x._1._1._1._1); }
          if (x._1._1._1.tag === "Inr") { return $ItemError("SoftError", x._1._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "MenuItemDisabled") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "InvalidQuantity") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "CustomProductsNotAvailable") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)));
    }
    if (x.tag === "FatalError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))); }
    if (x.tag === "SoftError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)))); }
    $runtime.fail();
  }
};
const showItemError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(MenuItemDisabledIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ requestedQuantity: " + Data$dShow.showIntImpl(v.requestedQuantity) + " }"]})(InvalidQuantityIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CustomProductsNotAvailableIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showFatalError.show(v)]})(FatalErrorIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showSoftError.show(v)]})(SoftErrorIsSymbol);
    return x => {
      const $5 = genericItemError.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeItemError = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(MenuItemDisabledIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(InvalidQuantityIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(requestedQuantityIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(CustomProductsNotAvailableIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(FatalErrorIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.unscrambleDecodeFatalError.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(SoftErrorIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.unscrambleDecodeSoftError.unsafeDecode(x.contents)
    }))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericItemError.to($0(x));
  })()
};
const genericFulfillmentMethod = {
  to: x => {
    if (x.tag === "Inl") { return $FulfillmentMethod("Delivery", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Takeaway; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $FulfillmentMethod("DineIn", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return $FulfillmentMethod("NoContactDelivery", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Delivery") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Takeaway") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "DineIn") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "NoContactDelivery") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const showFulfillmentMethod = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ customDeliveryPrice: " + (() => {
          if (v.customDeliveryPrice.tag === "Just") { return "(Just " + Data$dMoney$dRounded.toString(v.customDeliveryPrice._1) + ")"; }
          if (v.customDeliveryPrice.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })() + ", deliveryAddress: " + Restaumatic$dGeocoding$dTypes$dDeliveryAddress.showDeliveryAddress.show(v.deliveryAddress) + " " + "}"
      ]
    })(DeliveryIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(TakeawayIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.location.tag === "Just") { return "{ location: (Just " + Restaumatic$dOrders$dTypes$dDineInLocation.showDineInLocation.show(v.location._1) + ") }"; }
          if (v.location.tag === "Nothing") { return "{ location: Nothing }"; }
          $runtime.fail();
        })()
      ]
    })(DineInIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ deliveryAddress: " + Restaumatic$dGeocoding$dTypes$dDeliveryAddress.showDeliveryAddress.show(v.deliveryAddress) + " }"]
    })(NoContactDeliveryIsSymbol);
    return x => {
      const $4 = genericFulfillmentMethod.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeFulfillmentMethod = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(DeliveryIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(customDeliveryPriceIsSymbol)(Unscramble.decodeMaybe(Data$dMoney$dRounded.udecodeMoney))(decodeRecordCons1).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(TakeawayIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(DineInIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(locationIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dDineInLocation.unscrambleDecodeDineInLocation))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(NoContactDeliveryIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(decodeRecordCons1.recordInfo(Type$dProxy.Proxy))
    })))))(Unscramble$dGeneric.defaultOptions);
    return x => genericFulfillmentMethod.to($0(x));
  })()
};
const genericCustomer = {to: x => x, from: x => x};
const showCustomer = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ email: " + showMaybe.show(v.email) + ", fullName: " + Data$dShow.showStringImpl(v.fullName) + ", phone: " + showMaybe.show(v.phone) + (() => {
          if (v.subscribeEmail.tag === "Just") {
            if (v.subscribeEmail._1) {
              if (v.subscribePhone.tag === "Just") {
                if (v.subscribePhone._1) {
                  if (v.subscribeRestaumaticEmail.tag === "Just") {
                    if (v.subscribeRestaumaticEmail._1) {
                      if (v.subscribeRestaumaticPhone.tag === "Just") {
                        if (v.subscribeRestaumaticPhone._1) {
                          if (v.subscribed.tag === "Just") {
                            if (v.subscribed._1) {
                              if (v.subscribedRestaumatic.tag === "Just") {
                                if (v.subscribedRestaumatic._1) {
                                  return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                                }
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                              }
                              if (v.subscribedRestaumatic.tag === "Nothing") {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                              }
                              $runtime.fail();
                            }
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribed.tag === "Nothing") {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticEmail.tag === "Just") {
                  if (v.subscribeRestaumaticEmail._1) {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: " + (() => {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                              return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                            return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                            return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                            return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                          return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                          return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                            return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                          return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                          return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              if (v.subscribePhone.tag === "Nothing") {
                if (v.subscribeRestaumaticEmail.tag === "Just") {
                  if (v.subscribeRestaumaticEmail._1) {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just true), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            if (v.subscribePhone.tag === "Just") {
              if (v.subscribePhone._1) {
                if (v.subscribeRestaumaticEmail.tag === "Just") {
                  if (v.subscribeRestaumaticEmail._1) {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: " + (() => {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                              return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                            return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                            return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                            return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                          return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                          return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                            return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                          return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                          return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              if (v.subscribeRestaumaticEmail.tag === "Just") {
                if (v.subscribeRestaumaticEmail._1) {
                  return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: " + (() => {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                              return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                            return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                            return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                            return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                          return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                          return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                            return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                          return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                          return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: " + (() => {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                            return "(Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                          return "(Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                          return "(Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just true), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                          return "(Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                        return "(Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) { return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                        return "(Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") { return "(Just false), subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) "; }
                          return "Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing "; }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) "; }
                        return "Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing "; }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) { return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) "; }
                        return "Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") { return "Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                })();
              }
              if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                if (v.subscribeRestaumaticPhone.tag === "Just") {
                  if (v.subscribeRestaumaticPhone._1) {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            if (v.subscribePhone.tag === "Nothing") {
              if (v.subscribeRestaumaticEmail.tag === "Just") {
                if (v.subscribeRestaumaticEmail._1) {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Just") {
                  if (v.subscribeRestaumaticPhone._1) {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                if (v.subscribeRestaumaticPhone.tag === "Just") {
                  if (v.subscribeRestaumaticPhone._1) {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: (Just false), subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          if (v.subscribeEmail.tag === "Nothing") {
            if (v.subscribePhone.tag === "Just") {
              if (v.subscribePhone._1) {
                if (v.subscribeRestaumaticEmail.tag === "Just") {
                  if (v.subscribeRestaumaticEmail._1) {
                    if (v.subscribeRestaumaticPhone.tag === "Just") {
                      if (v.subscribeRestaumaticPhone._1) {
                        if (v.subscribed.tag === "Just") {
                          if (v.subscribed._1) {
                            if (v.subscribedRestaumatic.tag === "Just") {
                              if (v.subscribedRestaumatic._1) {
                                return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                              }
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                            }
                            if (v.subscribedRestaumatic.tag === "Nothing") {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                            }
                            $runtime.fail();
                          }
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribed.tag === "Nothing") {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just true), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              if (v.subscribeRestaumaticEmail.tag === "Just") {
                if (v.subscribeRestaumaticEmail._1) {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Just") {
                  if (v.subscribeRestaumaticPhone._1) {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                if (v.subscribeRestaumaticPhone.tag === "Just") {
                  if (v.subscribeRestaumaticPhone._1) {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: (Just false), subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            if (v.subscribePhone.tag === "Nothing") {
              if (v.subscribeRestaumaticEmail.tag === "Just") {
                if (v.subscribeRestaumaticEmail._1) {
                  if (v.subscribeRestaumaticPhone.tag === "Just") {
                    if (v.subscribeRestaumaticPhone._1) {
                      if (v.subscribed.tag === "Just") {
                        if (v.subscribed._1) {
                          if (v.subscribedRestaumatic.tag === "Just") {
                            if (v.subscribedRestaumatic._1) {
                              return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                            }
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                          }
                          if (v.subscribedRestaumatic.tag === "Nothing") {
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                          }
                          $runtime.fail();
                        }
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribed.tag === "Nothing") {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just true), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Just") {
                  if (v.subscribeRestaumaticPhone._1) {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: (Just false), subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              if (v.subscribeRestaumaticEmail.tag === "Nothing") {
                if (v.subscribeRestaumaticPhone.tag === "Just") {
                  if (v.subscribeRestaumaticPhone._1) {
                    if (v.subscribed.tag === "Just") {
                      if (v.subscribed._1) {
                        if (v.subscribedRestaumatic.tag === "Just") {
                          if (v.subscribedRestaumatic._1) {
                            return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                          }
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                        }
                        if (v.subscribedRestaumatic.tag === "Nothing") {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                        }
                        $runtime.fail();
                      }
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribed.tag === "Nothing") {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just true), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: (Just false), subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.subscribeRestaumaticPhone.tag === "Nothing") {
                  if (v.subscribed.tag === "Just") {
                    if (v.subscribed._1) {
                      if (v.subscribedRestaumatic.tag === "Just") {
                        if (v.subscribedRestaumatic._1) {
                          return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just true) ";
                        }
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: (Just false) ";
                      }
                      if (v.subscribedRestaumatic.tag === "Nothing") {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just true), subscribedRestaumatic: Nothing ";
                      }
                      $runtime.fail();
                    }
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: (Just false), subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  if (v.subscribed.tag === "Nothing") {
                    if (v.subscribedRestaumatic.tag === "Just") {
                      if (v.subscribedRestaumatic._1) {
                        return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just true) ";
                      }
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: (Just false) ";
                    }
                    if (v.subscribedRestaumatic.tag === "Nothing") {
                      return ", subscribeEmail: Nothing, subscribePhone: Nothing, subscribeRestaumaticEmail: Nothing, subscribeRestaumaticPhone: Nothing, subscribed: Nothing, subscribedRestaumatic: Nothing ";
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        })() + "}"
      ]
    })(CustomerIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCustomer = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(emailIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(fullNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(phoneIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(subscribeEmailIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(subscribePhoneIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(subscribeRestaumaticEmailIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(subscribeRestaumaticPhoneIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(subscribedIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(subscribedRestaumaticIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordNil))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCheckoutRequest = {to: x => x, from: x => x};
const showCheckoutRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dPromotions$dTypes$dPromotionalItem.showPromotionalItem.show);
      const $1 = Data$dShow.showArrayImpl(Data$dTuple$dT2.showT2(Data$dUUID.showUUID)({
        show: Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showContainedId.show)
      }).show);
      const $2 = (v, record) => {
        if (record.packagingContainers.tag === "Just") {
          return " packagingContainers: (Just " + $1(record.packagingContainers._1) + ")" + ", paymentMethod: " + Restaumatic$dOrders$dTypes$dPaymentMethod.showPaymentMethod.show(record.paymentMethod) + ", promotionalItems: " + $0(record.promotionalItems) + (() => {
            if (record.requestedFulfillmentTime.tag === "Just") {
              return ", requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(record.requestedFulfillmentTime._1) + ")" + ", restaurantId: " + Data$dShow.showIntImpl(record.restaurantId) + (() => {
                if (record.tip.tag === "Just") {
                  return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(record.tip._1) + ")" + ", userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                if (record.tip.tag === "Nothing") {
                  return ", tip: Nothing, userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                $runtime.fail();
              })();
            }
            if (record.requestedFulfillmentTime.tag === "Nothing") {
              return ", requestedFulfillmentTime: Nothing, restaurantId: " + Data$dShow.showIntImpl(record.restaurantId) + (() => {
                if (record.tip.tag === "Just") {
                  return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(record.tip._1) + ")" + ", userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                if (record.tip.tag === "Nothing") {
                  return ", tip: Nothing, userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                $runtime.fail();
              })();
            }
            $runtime.fail();
          })();
        }
        if (record.packagingContainers.tag === "Nothing") {
          return " packagingContainers: Nothing, paymentMethod: " + Restaumatic$dOrders$dTypes$dPaymentMethod.showPaymentMethod.show(record.paymentMethod) + ", promotionalItems: " + $0(record.promotionalItems) + (() => {
            if (record.requestedFulfillmentTime.tag === "Just") {
              return ", requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(record.requestedFulfillmentTime._1) + ")" + ", restaurantId: " + Data$dShow.showIntImpl(record.restaurantId) + (() => {
                if (record.tip.tag === "Just") {
                  return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(record.tip._1) + ")" + ", userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                if (record.tip.tag === "Nothing") {
                  return ", tip: Nothing, userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                $runtime.fail();
              })();
            }
            if (record.requestedFulfillmentTime.tag === "Nothing") {
              return ", requestedFulfillmentTime: Nothing, restaurantId: " + Data$dShow.showIntImpl(record.restaurantId) + (() => {
                if (record.tip.tag === "Just") {
                  return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(record.tip._1) + ")" + ", userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                if (record.tip.tag === "Nothing") {
                  return ", tip: Nothing, userNote: " + showMaybe.show(record.userNote) + (() => {
                    if (record.vatId.tag === "Just") {
                      return ", vatId: (Just " + Restaumatic$dVatId.showVatId.show(record.vatId._1) + ")" + (() => {
                        if (record.waiterPin.tag === "Just") { return ", waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                        if (record.waiterPin.tag === "Nothing") { return ", waiterPin: Nothing "; }
                        $runtime.fail();
                      })();
                    }
                    if (record.vatId.tag === "Nothing") {
                      if (record.waiterPin.tag === "Just") { return ", vatId: Nothing, waiterPin: (Just " + Data$dShow.showIntImpl(record.waiterPin._1) + ") "; }
                      if (record.waiterPin.tag === "Nothing") { return ", vatId: Nothing, waiterPin: Nothing "; }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  })();
                }
                $runtime.fail();
              })();
            }
            $runtime.fail();
          })();
        }
        $runtime.fail();
      };
      const $3 = Data$dMap$dInternal.showMap(Data$dShow.showString)(Data$dShow.showString);
      const $4 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {
        genericShowArgs: v => [
          "{ couponCodes: " + $4(v.couponCodes) + ", customer: " + showCustomer.show(v.customer) + (() => {
            if (v.draft.tag === "Just") {
              return ", draft: (Just " + Restaumatic$dOrders$dTypes$dOrderDraft.showOrderDraft.show(v.draft._1) + ")" + (() => {
                if (v.extraDiscount.tag === "Just") {
                  return ", extraDiscount: (Just " + Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.showExtraDiscount.show(v.extraDiscount._1) + ")" + ", fieldTestExperiments: " + (() => {
                    if (v.fieldTestExperiments.tag === "Just") { return "(Just " + $3.show(v.fieldTestExperiments._1) + ")"; }
                    if (v.fieldTestExperiments.tag === "Nothing") { return "Nothing"; }
                    $runtime.fail();
                  })() + ", fulfillmentMethod: " + showFulfillmentMethod.show(v.fulfillmentMethod) + (() => {
                    if (v.isIosReviewMode.tag === "Just") {
                      if (v.isIosReviewMode._1) {
                        return ", isIosReviewMode: (Just true), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                          if (v.origin.tag === "Just") {
                            return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                          }
                          if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                          $runtime.fail();
                        })();
                      }
                      return ", isIosReviewMode: (Just false), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                        if (v.origin.tag === "Just") {
                          return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                        }
                        if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                        $runtime.fail();
                      })();
                    }
                    if (v.isIosReviewMode.tag === "Nothing") {
                      return ", isIosReviewMode: Nothing, items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                        if (v.origin.tag === "Just") {
                          return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                        }
                        if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  })();
                }
                if (v.extraDiscount.tag === "Nothing") {
                  return ", extraDiscount: Nothing, fieldTestExperiments: " + (() => {
                    if (v.fieldTestExperiments.tag === "Just") { return "(Just " + $3.show(v.fieldTestExperiments._1) + ")"; }
                    if (v.fieldTestExperiments.tag === "Nothing") { return "Nothing"; }
                    $runtime.fail();
                  })() + ", fulfillmentMethod: " + showFulfillmentMethod.show(v.fulfillmentMethod) + (() => {
                    if (v.isIosReviewMode.tag === "Just") {
                      if (v.isIosReviewMode._1) {
                        return ", isIosReviewMode: (Just true), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                          if (v.origin.tag === "Just") {
                            return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                          }
                          if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                          $runtime.fail();
                        })();
                      }
                      return ", isIosReviewMode: (Just false), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                        if (v.origin.tag === "Just") {
                          return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                        }
                        if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                        $runtime.fail();
                      })();
                    }
                    if (v.isIosReviewMode.tag === "Nothing") {
                      return ", isIosReviewMode: Nothing, items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                        if (v.origin.tag === "Just") {
                          return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                        }
                        if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  })();
                }
                $runtime.fail();
              })();
            }
            if (v.draft.tag === "Nothing") {
              if (v.extraDiscount.tag === "Just") {
                return ", draft: Nothing, extraDiscount: (Just " + Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.showExtraDiscount.show(v.extraDiscount._1) + ")" + ", fieldTestExperiments: " + (() => {
                  if (v.fieldTestExperiments.tag === "Just") { return "(Just " + $3.show(v.fieldTestExperiments._1) + ")"; }
                  if (v.fieldTestExperiments.tag === "Nothing") { return "Nothing"; }
                  $runtime.fail();
                })() + ", fulfillmentMethod: " + showFulfillmentMethod.show(v.fulfillmentMethod) + (() => {
                  if (v.isIosReviewMode.tag === "Just") {
                    if (v.isIosReviewMode._1) {
                      return ", isIosReviewMode: (Just true), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                        if (v.origin.tag === "Just") {
                          return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                        }
                        if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                        $runtime.fail();
                      })();
                    }
                    return ", isIosReviewMode: (Just false), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                      if (v.origin.tag === "Just") {
                        return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                      }
                      if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                      $runtime.fail();
                    })();
                  }
                  if (v.isIosReviewMode.tag === "Nothing") {
                    return ", isIosReviewMode: Nothing, items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                      if (v.origin.tag === "Just") {
                        return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                      }
                      if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                      $runtime.fail();
                    })();
                  }
                  $runtime.fail();
                })();
              }
              if (v.extraDiscount.tag === "Nothing") {
                return ", draft: Nothing, extraDiscount: Nothing, fieldTestExperiments: " + (() => {
                  if (v.fieldTestExperiments.tag === "Just") { return "(Just " + $3.show(v.fieldTestExperiments._1) + ")"; }
                  if (v.fieldTestExperiments.tag === "Nothing") { return "Nothing"; }
                  $runtime.fail();
                })() + ", fulfillmentMethod: " + showFulfillmentMethod.show(v.fulfillmentMethod) + (() => {
                  if (v.isIosReviewMode.tag === "Just") {
                    if (v.isIosReviewMode._1) {
                      return ", isIosReviewMode: (Just true), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                        if (v.origin.tag === "Just") {
                          return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                        }
                        if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                        $runtime.fail();
                      })();
                    }
                    return ", isIosReviewMode: (Just false), items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                      if (v.origin.tag === "Just") {
                        return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                      }
                      if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                      $runtime.fail();
                    })();
                  }
                  if (v.isIosReviewMode.tag === "Nothing") {
                    return ", isIosReviewMode: Nothing, items: " + showArray.show(v.items) + ", locale: " + Restaumatic$dLocales.showLocale.show(v.locale) + (() => {
                      if (v.origin.tag === "Just") {
                        return ", origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + "," + $2(Type$dProxy.Proxy, v);
                      }
                      if (v.origin.tag === "Nothing") { return ", origin: Nothing," + $2(Type$dProxy.Proxy, v); }
                      $runtime.fail();
                    })();
                  }
                  $runtime.fail();
                })();
              }
              $runtime.fail();
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(CheckoutRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCheckoutRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(couponCodesIsSymbol)({unsafeDecode: Unscramble.decodeArray(Unscramble.decodeString)})(Unscramble.decodeRecordCons(customerIsSymbol)(unscrambleDecodeCustomer)(Unscramble.decodeRecordCons(draftIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dOrderDraft.unscrambleDecodeOrderDraft))(Unscramble.decodeRecordCons(extraDiscountIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.unscrambleDecodeExtraDiscount))(Unscramble.decodeRecordCons(fieldTestExperimentsIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeMap(Unscramble.fromJSONKeyString)(Data$dOrd.ordString)(Unscramble.decodeString1)))(Unscramble.decodeRecordCons(fulfillmentMethodIsSymbol)(unscrambleDecodeFulfillmentMethod)(Unscramble.decodeRecordCons(isIosReviewModeIsSymbol)(decodeMaybe1)(decodeRecordCons5(Unscramble.decodeRecordCons(localeIsSymbol)(Restaumatic$dLocales.udecodeLocale)(Unscramble.decodeRecordCons(originIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dOrderOrigin.unscrambleDecodeOrderOrigin))(Unscramble.decodeRecordCons(packagingContainersIsSymbol)(Unscramble.decodeMaybe({
      unsafeDecode: Unscramble.decodeArray(Data$dTuple$dT2.udecodeT2(Data$dUUID.udecodeUUID)({
        unsafeDecode: Unscramble.decodeArray(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodeContainedId.unsafeDecode)
      }).unsafeDecode)
    }))(Unscramble.decodeRecordCons(paymentMethodIsSymbol)(Restaumatic$dOrders$dTypes$dPaymentMethod.unscrambleDecodePaymentMethod)(Unscramble.decodeRecordCons(promotionalItemsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dPromotions$dTypes$dPromotionalItem.unscrambleDecodePromotionalItem.unsafeDecode)
    })(Unscramble.decodeRecordCons(requestedFulfillmentTimeIsSymbol)(Unscramble.decodeMaybe(Data$dUTCTime.unscrambleDecodeUTCTime))(Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(tipIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dTip.unscrambleDecodeTip))(Unscramble.decodeRecordCons(userNoteIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(vatIdIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dVatId.unscrambleDecodeVatId))(Unscramble.decodeRecordCons(waiterPinIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordNil))))))))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCheckoutError = {
  to: x => {
    if (x.tag === "Inl") { return RestaurantDoesNotExist; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return AccountDoesNotExist; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return InvalidUserInSession; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return OrderDoesNotExist; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return OrderNotEditable; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return RegisteredUserShouldLogIn; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return EmailNotProvidedAndNotLoggedIn; }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return InvalidEmail; }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return InvalidPhoneNumber; }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return QrWaiterDisabled; }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return FulfillmentMethodNotSupported; }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return PaymentMethodNotSupported; }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return TipsNotAllowed; }
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return NegativeTip; }
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return InvalidVatId; }
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return LocaleNotEnabled; }
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return NotInDeliveryArea; }
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return CoordinatesNotProvided; }
                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                          return $CheckoutError("OrderValueTooLow", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                            return $CheckoutError("OrderValueTooHigh", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                          }
                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return DelayedDeliveryNotEnabled; }
                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                return $CheckoutError("RequestedDeliveryTimeTooShort", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                              }
                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return OutsideOfOrderingHours; }
                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                    return DelayedDeliveryOutsideOfOrderingHours;
                                                  }
                                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                      return $CheckoutError(
                                                        "PromotionValidationErrors",
                                                        x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1
                                                      );
                                                    }
                                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return InvalidCoupon; }
                                                      if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                          return $CheckoutError("ItemError", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                        }
                                                        if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                            return FodAlreadyOrderedToAddress;
                                                          }
                                                          if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                              return ExtraDiscountNotAllowed;
                                                            }
                                                            if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                return ForbiddenOrigin;
                                                              }
                                                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                  return OriginNotProvided;
                                                                }
                                                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                    return $CheckoutError(
                                                                      "PaymentError",
                                                                      x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1
                                                                    );
                                                                  }
                                                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (
                                                                      x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl"
                                                                    ) {
                                                                      return InvalidPackagingAssignment;
                                                                    }
                                                                    if (
                                                                      x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr"
                                                                    ) {
                                                                      return SmsVerificationRequired;
                                                                    }
                                                                    $runtime.fail();
                                                                  }
                                                                  $runtime.fail();
                                                                }
                                                                $runtime.fail();
                                                              }
                                                              $runtime.fail();
                                                            }
                                                            $runtime.fail();
                                                          }
                                                          $runtime.fail();
                                                        }
                                                        $runtime.fail();
                                                      }
                                                      $runtime.fail();
                                                    }
                                                    $runtime.fail();
                                                  }
                                                  $runtime.fail();
                                                }
                                                $runtime.fail();
                                              }
                                              $runtime.fail();
                                            }
                                            $runtime.fail();
                                          }
                                          $runtime.fail();
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "RestaurantDoesNotExist") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "AccountDoesNotExist") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "InvalidUserInSession") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "OrderDoesNotExist") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "OrderNotEditable") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "RegisteredUserShouldLogIn") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "EmailNotProvidedAndNotLoggedIn") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "InvalidEmail") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
            )
          )
        )
      );
    }
    if (x.tag === "InvalidPhoneNumber") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
              )
            )
          )
        )
      );
    }
    if (x.tag === "QrWaiterDisabled") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "FulfillmentMethodNotSupported") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PaymentMethodNotSupported") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "TipsNotAllowed") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "NegativeTip") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidVatId") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "LocaleNotEnabled") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "NotInDeliveryArea") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "CoordinatesNotProvided") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OrderValueTooLow") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OrderValueTooHigh") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "DelayedDeliveryNotEnabled") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "RequestedDeliveryTimeTooShort") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OutsideOfOrderingHours") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "DelayedDeliveryOutsideOfOrderingHours") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PromotionValidationErrors") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidCoupon") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ItemError") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "FodAlreadyOrderedToAddress") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ExtraDiscountNotAllowed") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ForbiddenOrigin") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum(
                                                              "Inr",
                                                              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                            )
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OriginNotProvided") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum(
                                                              "Inr",
                                                              Data$dGeneric$dRep.$Sum(
                                                                "Inr",
                                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                              )
                                                            )
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PaymentError") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum(
                                                              "Inr",
                                                              Data$dGeneric$dRep.$Sum(
                                                                "Inr",
                                                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))
                                                              )
                                                            )
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidPackagingAssignment") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum(
                                                              "Inr",
                                                              Data$dGeneric$dRep.$Sum(
                                                                "Inr",
                                                                Data$dGeneric$dRep.$Sum(
                                                                  "Inr",
                                                                  Data$dGeneric$dRep.$Sum(
                                                                    "Inr",
                                                                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))
                                                                  )
                                                                )
                                                              )
                                                            )
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "SmsVerificationRequired") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum(
                                    "Inr",
                                    Data$dGeneric$dRep.$Sum(
                                      "Inr",
                                      Data$dGeneric$dRep.$Sum(
                                        "Inr",
                                        Data$dGeneric$dRep.$Sum(
                                          "Inr",
                                          Data$dGeneric$dRep.$Sum(
                                            "Inr",
                                            Data$dGeneric$dRep.$Sum(
                                              "Inr",
                                              Data$dGeneric$dRep.$Sum(
                                                "Inr",
                                                Data$dGeneric$dRep.$Sum(
                                                  "Inr",
                                                  Data$dGeneric$dRep.$Sum(
                                                    "Inr",
                                                    Data$dGeneric$dRep.$Sum(
                                                      "Inr",
                                                      Data$dGeneric$dRep.$Sum(
                                                        "Inr",
                                                        Data$dGeneric$dRep.$Sum(
                                                          "Inr",
                                                          Data$dGeneric$dRep.$Sum(
                                                            "Inr",
                                                            Data$dGeneric$dRep.$Sum(
                                                              "Inr",
                                                              Data$dGeneric$dRep.$Sum(
                                                                "Inr",
                                                                Data$dGeneric$dRep.$Sum(
                                                                  "Inr",
                                                                  Data$dGeneric$dRep.$Sum(
                                                                    "Inr",
                                                                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))
                                                                  )
                                                                )
                                                              )
                                                            )
                                                          )
                                                        )
                                                      )
                                                    )
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showCheckoutError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(RestaurantDoesNotExistIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(AccountDoesNotExistIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InvalidUserInSessionIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OrderDoesNotExistIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OrderNotEditableIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(RegisteredUserShouldLogInIsSymbol);
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(EmailNotProvidedAndNotLoggedInIsSymbol);
    const $7 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InvalidEmailIsSymbol);
    const $8 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InvalidPhoneNumberIsSymbol);
    const $9 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(QrWaiterDisabledIsSymbol);
    const $10 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(FulfillmentMethodNotSupportedIsSymbol);
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PaymentMethodNotSupportedIsSymbol);
    const $12 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(TipsNotAllowedIsSymbol);
    const $13 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NegativeTipIsSymbol);
    const $14 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InvalidVatIdIsSymbol);
    const $15 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(LocaleNotEnabledIsSymbol);
    const $16 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NotInDeliveryAreaIsSymbol);
    const $17 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CoordinatesNotProvidedIsSymbol);
    const $18 = genericShowConstructor1(OrderValueTooLowIsSymbol);
    const $19 = genericShowConstructor1(OrderValueTooHighIsSymbol);
    const $20 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DelayedDeliveryNotEnabledIsSymbol);
    const $21 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ difference: (Seconds " + Data$dShow.showNumberImpl(v.difference) + ") }"]})(RequestedDeliveryTimeTooShortIsSymbol);
    const $22 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OutsideOfOrderingHoursIsSymbol);
    const $23 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DelayedDeliveryOutsideOfOrderingHoursIsSymbol);
    const $24 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dValidation$dTypes.showValidationErrors.show(v)]})(PromotionValidationErrorsIsSymbol);
    const $25 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InvalidCouponIsSymbol);
    const $26 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ groupIndex: " + Data$dShow.showIntImpl(v.groupIndex) + ", itemError: " + showItemError.show(v.itemError) + ", name: " + showMaybe.show(v.name) + " " + "}"
      ]
    })(ItemErrorIsSymbol);
    const $27 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(FodAlreadyOrderedToAddressIsSymbol);
    const $28 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ExtraDiscountNotAllowedIsSymbol);
    const $29 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ForbiddenOriginIsSymbol);
    const $30 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OriginNotProvidedIsSymbol);
    const $31 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dOrders$dPayments$dTypes$dPaymentError.showError.show(v)]})(PaymentErrorIsSymbol);
    const $32 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InvalidPackagingAssignmentIsSymbol);
    const $33 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(SmsVerificationRequiredIsSymbol);
    return x => {
      const $34 = genericCheckoutError.from(x);
      if ($34.tag === "Inl") { return $0["genericShow'"]($34._1); }
      if ($34.tag === "Inr") {
        if ($34._1.tag === "Inl") { return $1["genericShow'"]($34._1._1); }
        if ($34._1.tag === "Inr") {
          if ($34._1._1.tag === "Inl") { return $2["genericShow'"]($34._1._1._1); }
          if ($34._1._1.tag === "Inr") {
            if ($34._1._1._1.tag === "Inl") { return $3["genericShow'"]($34._1._1._1._1); }
            if ($34._1._1._1.tag === "Inr") {
              if ($34._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($34._1._1._1._1._1); }
              if ($34._1._1._1._1.tag === "Inr") {
                if ($34._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($34._1._1._1._1._1._1); }
                if ($34._1._1._1._1._1.tag === "Inr") {
                  if ($34._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($34._1._1._1._1._1._1._1); }
                  if ($34._1._1._1._1._1._1.tag === "Inr") {
                    if ($34._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($34._1._1._1._1._1._1._1._1); }
                    if ($34._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($34._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($34._1._1._1._1._1._1._1._1._1); }
                      if ($34._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($34._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1); }
                        if ($34._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($34._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($34._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($34._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($34._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if ($34._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $12["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                              if ($34._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $13["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $14["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                  if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $15["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $16["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                          return $17["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                            return $18["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                          }
                                          if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                            if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                              return $19["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                            }
                                            if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                              if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                return $20["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                              }
                                              if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                  return $21["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                }
                                                if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                  if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                    return $22["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                  }
                                                  if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                      return $23["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                    }
                                                    if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                      if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                        return $24["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                      }
                                                      if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                          return $25["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                        }
                                                        if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                          if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                            return $26["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                          }
                                                          if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                              return $27["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            }
                                                            if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                              if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                return $28["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                              }
                                                              if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                  return $29["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                }
                                                                if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                  if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                    return $30["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                  }
                                                                  if ($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (
                                                                      $34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl"
                                                                    ) {
                                                                      return $31["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                    }
                                                                    if (
                                                                      $34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr"
                                                                    ) {
                                                                      if (
                                                                        $34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl"
                                                                      ) {
                                                                        return $32["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                      }
                                                                      if (
                                                                        $34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr"
                                                                      ) {
                                                                        return $33["genericShow'"]($34._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                      }
                                                                      $runtime.fail();
                                                                    }
                                                                    $runtime.fail();
                                                                  }
                                                                  $runtime.fail();
                                                                }
                                                                $runtime.fail();
                                                              }
                                                              $runtime.fail();
                                                            }
                                                            $runtime.fail();
                                                          }
                                                          $runtime.fail();
                                                        }
                                                        $runtime.fail();
                                                      }
                                                      $runtime.fail();
                                                    }
                                                    $runtime.fail();
                                                  }
                                                  $runtime.fail();
                                                }
                                                $runtime.fail();
                                              }
                                              $runtime.fail();
                                            }
                                            $runtime.fail();
                                          }
                                          $runtime.fail();
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeCheckoutError = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(RestaurantDoesNotExistIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(AccountDoesNotExistIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(InvalidUserInSessionIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OrderDoesNotExistIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OrderNotEditableIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(RegisteredUserShouldLogInIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(EmailNotProvidedAndNotLoggedInIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(InvalidEmailIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(InvalidPhoneNumberIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(QrWaiterDisabledIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(FulfillmentMethodNotSupportedIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(PaymentMethodNotSupportedIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(TipsNotAllowedIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(NegativeTipIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(InvalidVatIdIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(LocaleNotEnabledIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(NotInDeliveryAreaIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(CoordinatesNotProvidedIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(OrderValueTooLowIsSymbol)(decodeSingleConstructorAr1))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(OrderValueTooHighIsSymbol)(decodeSingleConstructorAr1))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(DelayedDeliveryNotEnabledIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(RequestedDeliveryTimeTooShortIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(differenceIsSymbol)(Data$dTime$dDuration$dSerialized.udecodeSeconds)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OutsideOfOrderingHoursIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(DelayedDeliveryOutsideOfOrderingHoursIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PromotionValidationErrorsIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dValidation$dTypes.decodeValidationErrors.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(InvalidCouponIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ItemErrorIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(groupIndexIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(itemErrorIsSymbol)(unscrambleDecodeItemError)(Unscramble.decodeRecordCons(nameIsSymbol)(decodeMaybe)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(FodAlreadyOrderedToAddressIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(ExtraDiscountNotAllowedIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(ForbiddenOriginIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OriginNotProvidedIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PaymentErrorIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dOrders$dPayments$dTypes$dPaymentError.unscrambleDecodeError.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(InvalidPackagingAssignmentIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(SmsVerificationRequiredIsSymbol)))))))))))))))))))))))))))))))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericCheckoutError.to($0(x));
  })()
};
const encodeProductItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ProductItemIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(quantityIsSymbol)(encodeWithOptionsOther))(productKeyIsSymbol)({
      encodeWithOptions: v => Restaumatic$dCart$dProductKey.encodeProductKey.encode
    }))(noteIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeWithOptionsOther5 = /* #__PURE__ */ (() => {
  const encode1 = Data$dFunctor.arrayMap(encodeProductItem.encode);
  return {encodeWithOptions: v => encode1};
})();
const encodeOrderSplit = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericOrderSplit)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(OrderSplitIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(itemsIsSymbol)(encodeWithOptionsOther5))(draftIsSymbol)({
      encodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderDraft.encodeOrderDraft.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeItemError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericItemError)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(MenuItemDisabledIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidQuantityIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(requestedQuantityIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(CustomProductsNotAvailableIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(FatalErrorIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeFatalError.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(SoftErrorIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeSoftError.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeFulfillmentMethod = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericFulfillmentMethod)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(DeliveryIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(encodeRecordCons2)(customDeliveryPriceIsSymbol)({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Data$dInt.toNumber(v2._1) / 100.0; }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(TakeawayIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(DineInIsSymbol)((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(locationIsSymbol)({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dDineInLocation.encodeDineInLocation.encode(v2._1); }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(NoContactDeliveryIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", encodeRecordCons2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeCustomer = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCustomer)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CustomerIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(subscribedRestaumaticIsSymbol)(encodeWithOptionsOther2))(subscribedIsSymbol)(encodeWithOptionsOther2))(subscribeRestaumaticPhoneIsSymbol)(encodeWithOptionsOther2))(subscribeRestaumaticEmailIsSymbol)(encodeWithOptionsOther2))(subscribePhoneIsSymbol)(encodeWithOptionsOther2))(subscribeEmailIsSymbol)(encodeWithOptionsOther2))(phoneIsSymbol)(encodeWithOptionsOther1))(fullNameIsSymbol)(encodeWithOptionsOther3))(emailIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCheckoutRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCheckoutRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CheckoutRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(waiterPinIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))(vatIdIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dVatId.encodeVatId.encode(v2._1); }
        $runtime.fail();
      }
    }))(userNoteIsSymbol)(encodeWithOptionsOther1))(tipIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dTip.encodeTip.encode(v2._1); }
        $runtime.fail();
      }
    }))(restaurantIdIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(requestedFulfillmentTimeIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return DateUtils.formatISODateTime(v2._1); }
        $runtime.fail();
      }
    }))(promotionalItemsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dPromotions$dTypes$dPromotionalItem.encodePromotionalItem.encode);
      return {encodeWithOptions: v => encode1};
    })()))(paymentMethodIsSymbol)({encodeWithOptions: v => Restaumatic$dOrders$dTypes$dPaymentMethod.encodePaymentMethod.encode}))(packagingContainersIsSymbol)((() => {
      const $0 = Data$dFunctor.arrayMap((() => {
        const encode1 = Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodeContainedId.encode);
        return Foreign$dEncoding.defaultEncode(Data$dTuple$dT2.genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor(Data$dTuple$dT2.T2IsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
          encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
        })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encode1(v)), Data$dList$dTypes.Nil)})));
      })());
      return {
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return $0(v2._1); }
          $runtime.fail();
        }
      };
    })()))(originIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.encodeOrderOrigin.encode(v2._1); }
        $runtime.fail();
      }
    }))(localeIsSymbol)({encodeWithOptions: v => Restaumatic$dLocales.encodeLocale.encode}))(itemsIsSymbol)(encodeWithOptionsOther5))(isIosReviewModeIsSymbol)(encodeWithOptionsOther2))(fulfillmentMethodIsSymbol)({
      encodeWithOptions: v => encodeFulfillmentMethod.encode
    }))(fieldTestExperimentsIsSymbol)((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Data$dMap$dSerialized.asJSONKeyString)(Foreign$dGeneric$dClass.stringEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return $0.encode(v2._1); }
          $runtime.fail();
        }
      };
    })()))(extraDiscountIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.encodeExtraDiscount.encode(v2._1); }
        $runtime.fail();
      }
    }))(draftIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") {
          return Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dOrders$dTypes$dOrderDraft.OrderDraftIsSymbol)({
            encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
          }).encodeOpts(Foreign$dEncoding.options)(v2._1);
        }
        $runtime.fail();
      }
    }))(customerIsSymbol)({encodeWithOptions: v => encodeCustomer.encode}))(couponCodesIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCheckoutError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCheckoutError)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(RestaurantDoesNotExistIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(AccountDoesNotExistIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidUserInSessionIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(OrderDoesNotExistIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(OrderNotEditableIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor(RegisteredUserShouldLogInIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $6 = Foreign$dGeneric$dClass.genericEncodeConstructor(EmailNotProvidedAndNotLoggedInIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $7 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidEmailIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $8 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidPhoneNumberIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $9 = Foreign$dGeneric$dClass.genericEncodeConstructor(QrWaiterDisabledIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $10 = Foreign$dGeneric$dClass.genericEncodeConstructor(FulfillmentMethodNotSupportedIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $11 = Foreign$dGeneric$dClass.genericEncodeConstructor(PaymentMethodNotSupportedIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $12 = Foreign$dGeneric$dClass.genericEncodeConstructor(TipsNotAllowedIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $13 = Foreign$dGeneric$dClass.genericEncodeConstructor(NegativeTipIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $14 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidVatIdIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $15 = Foreign$dGeneric$dClass.genericEncodeConstructor(LocaleNotEnabledIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $16 = Foreign$dGeneric$dClass.genericEncodeConstructor(NotInDeliveryAreaIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $17 = Foreign$dGeneric$dClass.genericEncodeConstructor(CoordinatesNotProvidedIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $18 = Foreign$dGeneric$dClass.genericEncodeConstructor(OrderValueTooLowIsSymbol)(genericEncodeArgsRecord);
    const $19 = Foreign$dGeneric$dClass.genericEncodeConstructor(OrderValueTooHighIsSymbol)(genericEncodeArgsRecord);
    const $20 = Foreign$dGeneric$dClass.genericEncodeConstructor(DelayedDeliveryNotEnabledIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $21 = Foreign$dGeneric$dClass.genericEncodeConstructor(RequestedDeliveryTimeTooShortIsSymbol)((() => {
      const $21 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(differenceIsSymbol)({
        encodeWithOptions: v => Data$dTime$dDuration$dSerialized.encodeSeconds.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $21.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $22 = Foreign$dGeneric$dClass.genericEncodeConstructor(OutsideOfOrderingHoursIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $23 = Foreign$dGeneric$dClass.genericEncodeConstructor(DelayedDeliveryOutsideOfOrderingHoursIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $24 = Foreign$dGeneric$dClass.genericEncodeConstructor(PromotionValidationErrorsIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dValidation$dTypes.encodeValidationErrors.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $25 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidCouponIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $26 = Foreign$dGeneric$dClass.genericEncodeConstructor(ItemErrorIsSymbol)((() => {
      const $26 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(nameIsSymbol)(encodeWithOptionsOther1))(itemErrorIsSymbol)({
        encodeWithOptions: v => encodeItemError.encode
      }))(groupIndexIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $26.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $27 = Foreign$dGeneric$dClass.genericEncodeConstructor(FodAlreadyOrderedToAddressIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $28 = Foreign$dGeneric$dClass.genericEncodeConstructor(ExtraDiscountNotAllowedIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $29 = Foreign$dGeneric$dClass.genericEncodeConstructor(ForbiddenOriginIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $30 = Foreign$dGeneric$dClass.genericEncodeConstructor(OriginNotProvidedIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $31 = Foreign$dGeneric$dClass.genericEncodeConstructor(PaymentErrorIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dOrders$dPayments$dTypes$dPaymentError.encodeError.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $32 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidPackagingAssignmentIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $33 = Foreign$dGeneric$dClass.genericEncodeConstructor(SmsVerificationRequiredIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1.tag === "Inl") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1); }
                if (v1._1._1._1._1.tag === "Inr") {
                  if (v1._1._1._1._1._1.tag === "Inl") { return $5.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1); }
                  if (v1._1._1._1._1._1.tag === "Inr") {
                    if (v1._1._1._1._1._1._1.tag === "Inl") { return $6.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1); }
                    if (v1._1._1._1._1._1._1.tag === "Inr") {
                      if (v1._1._1._1._1._1._1._1.tag === "Inl") { return $7.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1); }
                      if (v1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (v1._1._1._1._1._1._1._1._1.tag === "Inl") { return $8.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1); }
                        if (v1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (v1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1); }
                          if (v1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                              return $10.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (v1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                return $11.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1);
                              }
                              if (v1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                  return $12.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                }
                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                    return $13.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                  }
                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $14.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $15.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                          return $16.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                            return $17.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                          }
                                          if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                              return $18.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                            }
                                            if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                              if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                return $19.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                              }
                                              if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                  return $20.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                }
                                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                    return $21.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                  }
                                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                      return $22.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                    }
                                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                      if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                        return $23.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                      }
                                                      if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                          return $24.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                        }
                                                        if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                          if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                            return $25.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                          }
                                                          if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                              return $26.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            }
                                                            if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                              if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                return $27.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                              }
                                                              if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                  return $28.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                }
                                                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                    return $29.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                  }
                                                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                                                      return $30.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                    }
                                                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                      if (
                                                                        v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl"
                                                                      ) {
                                                                        return $31.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                      }
                                                                      if (
                                                                        v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr"
                                                                      ) {
                                                                        if (
                                                                          v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl"
                                                                        ) {
                                                                          return $32.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                        }
                                                                        if (
                                                                          v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr"
                                                                        ) {
                                                                          return $33.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                        }
                                                                        $runtime.fail();
                                                                      }
                                                                      $runtime.fail();
                                                                    }
                                                                    $runtime.fail();
                                                                  }
                                                                  $runtime.fail();
                                                                }
                                                                $runtime.fail();
                                                              }
                                                              $runtime.fail();
                                                            }
                                                            $runtime.fail();
                                                          }
                                                          $runtime.fail();
                                                        }
                                                        $runtime.fail();
                                                      }
                                                      $runtime.fail();
                                                    }
                                                    $runtime.fail();
                                                  }
                                                  $runtime.fail();
                                                }
                                                $runtime.fail();
                                              }
                                              $runtime.fail();
                                            }
                                            $runtime.fail();
                                          }
                                          $runtime.fail();
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeProductItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductItemIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(quantityIsSymbol)(decodeWithOptionsOther)())(productKeyIsSymbol)({
    decodeWithOptions: v => Restaumatic$dCart$dProductKey.decodeProductKey.decode
  })())(noteIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeWithOptionsOther5 = /* #__PURE__ */ (() => {
  const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeProductItem).decode;
  return {decodeWithOptions: v => decode2};
})();
const decodeOrderSplit = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericOrderSplit)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderSplitIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(itemsIsSymbol)(decodeWithOptionsOther5)())(draftIsSymbol)({
    decodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderDraft.decodeOrderDraft.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeItemError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericItemError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MenuItemDisabledIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(InvalidQuantityIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(requestedQuantityIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomProductsNotAvailableIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FatalErrorIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.decodeFatalError.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SoftErrorIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.decodeSoftError.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))))))
};
const decodeFulfillmentMethod = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericFulfillmentMethod)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(DeliveryIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(decodeRecordCons4)(customDeliveryPriceIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dMoney$dRounded.decodeMoney.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(TakeawayIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(DineInIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(locationIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dDineInLocation.decodeDineInLocation.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(NoContactDeliveryIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(decodeRecordCons4)))(Foreign$dGeneric$dClass.genericCountArgsArgument)))))
};
const decodeCustomer = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCustomer)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomerIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(subscribedRestaumaticIsSymbol)(decodeWithOptionsOther2)())(subscribedIsSymbol)(decodeWithOptionsOther2)())(subscribeRestaumaticPhoneIsSymbol)(decodeWithOptionsOther2)())(subscribeRestaumaticEmailIsSymbol)(decodeWithOptionsOther2)())(subscribePhoneIsSymbol)(decodeWithOptionsOther2)())(subscribeEmailIsSymbol)(decodeWithOptionsOther2)())(phoneIsSymbol)(decodeWithOptionsOther1)())(fullNameIsSymbol)(decodeWithOptionsOther3)())(emailIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCheckoutRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCheckoutRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CheckoutRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(waiterPinIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)
  })())(vatIdIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dVatId.decodeVatId.decode)})())(userNoteIsSymbol)(decodeWithOptionsOther1)())(tipIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dTip.decodeTip.decode)
  })())(restaurantIdIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())(requestedFulfillmentTimeIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUTCTime.decodeUTCTime.decode)
  })())(promotionalItemsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dPromotions$dTypes$dPromotionalItem.decodePromotionalItem).decode;
    return {decodeWithOptions: v => decode2};
  })())())(paymentMethodIsSymbol)({decodeWithOptions: v => Restaumatic$dOrders$dTypes$dPaymentMethod.decodePaymentMethod.decode})())(packagingContainersIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.arrayDecode(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument((() => {
        const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodeContainedId).decode;
        return {decodeWithOptions: v => decode2};
      })()),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })).decode);
    return {decodeWithOptions: v => decode2};
  })())())(originIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dOrderOrigin.decodeOrderOrigin.decode)})())(localeIsSymbol)({
    decodeWithOptions: v => Restaumatic$dLocales.decodeLocale.decode
  })())(itemsIsSymbol)(decodeWithOptionsOther5)())(isIosReviewModeIsSymbol)(decodeWithOptionsOther2)())(fulfillmentMethodIsSymbol)({
    decodeWithOptions: v => decodeFulfillmentMethod.decode
  })())(fieldTestExperimentsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dNullOrUndefined.readNullOrUndefined(Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Data$dMap$dSerialized.asJSONKeyString)(Foreign$dGeneric$dClass.stringDecode)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther3),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }).decode);
    return {decodeWithOptions: v => decode2};
  })())())(extraDiscountIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.decodeExtraDiscount.decode)
  })())(draftIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dOrderDraft.decodeOrderDraft.decode)})())(customerIsSymbol)({
    decodeWithOptions: v => decodeCustomer.decode
  })())(couponCodesIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCheckoutError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCheckoutError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RestaurantDoesNotExistIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AccountDoesNotExistIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(InvalidUserInSessionIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderDoesNotExistIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderNotEditableIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RegisteredUserShouldLogInIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(EmailNotProvidedAndNotLoggedInIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(InvalidEmailIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(InvalidPhoneNumberIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(QrWaiterDisabledIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FulfillmentMethodNotSupportedIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PaymentMethodNotSupportedIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(TipsNotAllowedIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(NegativeTipIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(InvalidVatIdIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(LocaleNotEnabledIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(NotInDeliveryAreaIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CoordinatesNotProvidedIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderValueTooLowIsSymbol)(genericDecodeArgsRecord)(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderValueTooHighIsSymbol)(genericDecodeArgsRecord)(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(DelayedDeliveryNotEnabledIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RequestedDeliveryTimeTooShortIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(differenceIsSymbol)({
    decodeWithOptions: v => Data$dTime$dDuration$dSerialized.decodeSeconds.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OutsideOfOrderingHoursIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(DelayedDeliveryOutsideOfOrderingHoursIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PromotionValidationErrorsIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dValidation$dTypes.decodeValidationErrors1.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(InvalidCouponIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ItemErrorIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(nameIsSymbol)(decodeWithOptionsOther1)())(itemErrorIsSymbol)({
    decodeWithOptions: v => decodeItemError.decode
  })())(groupIndexIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FodAlreadyOrderedToAddressIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ExtraDiscountNotAllowedIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ForbiddenOriginIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OriginNotProvidedIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PaymentErrorIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dOrders$dPayments$dTypes$dPaymentError.decodeError.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(InvalidPackagingAssignmentIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SmsVerificationRequiredIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))))))))))))))))))))))))))))))))
};
export {
  $CheckoutError,
  $FulfillmentMethod,
  $ItemError,
  AccountDoesNotExist,
  AccountDoesNotExistIsSymbol,
  CheckoutRequest,
  CheckoutRequestIsSymbol,
  CoordinatesNotProvided,
  CoordinatesNotProvidedIsSymbol,
  CustomProductsNotAvailable,
  CustomProductsNotAvailableIsSymbol,
  Customer,
  CustomerIsSymbol,
  DelayedDeliveryNotEnabled,
  DelayedDeliveryNotEnabledIsSymbol,
  DelayedDeliveryOutsideOfOrderingHours,
  DelayedDeliveryOutsideOfOrderingHoursIsSymbol,
  Delivery,
  DeliveryIsSymbol,
  DineIn,
  DineInIsSymbol,
  EmailNotProvidedAndNotLoggedIn,
  EmailNotProvidedAndNotLoggedInIsSymbol,
  ExtraDiscountNotAllowed,
  ExtraDiscountNotAllowedIsSymbol,
  FatalError,
  FatalErrorIsSymbol,
  FodAlreadyOrderedToAddress,
  FodAlreadyOrderedToAddressIsSymbol,
  ForbiddenOrigin,
  ForbiddenOriginIsSymbol,
  FulfillmentMethodNotSupported,
  FulfillmentMethodNotSupportedIsSymbol,
  InvalidCoupon,
  InvalidCouponIsSymbol,
  InvalidEmail,
  InvalidEmailIsSymbol,
  InvalidPackagingAssignment,
  InvalidPackagingAssignmentIsSymbol,
  InvalidPhoneNumber,
  InvalidPhoneNumberIsSymbol,
  InvalidQuantity,
  InvalidQuantityIsSymbol,
  InvalidUserInSession,
  InvalidUserInSessionIsSymbol,
  InvalidVatId,
  InvalidVatIdIsSymbol,
  ItemError,
  ItemErrorIsSymbol,
  LocaleNotEnabled,
  LocaleNotEnabledIsSymbol,
  MenuItemDisabled,
  MenuItemDisabledIsSymbol,
  NegativeTip,
  NegativeTipIsSymbol,
  NoContactDelivery,
  NoContactDeliveryIsSymbol,
  NotInDeliveryArea,
  NotInDeliveryAreaIsSymbol,
  OrderDoesNotExist,
  OrderDoesNotExistIsSymbol,
  OrderNotEditable,
  OrderNotEditableIsSymbol,
  OrderSplit,
  OrderSplitIsSymbol,
  OrderValueTooHigh,
  OrderValueTooHighIsSymbol,
  OrderValueTooLow,
  OrderValueTooLowIsSymbol,
  OriginNotProvided,
  OriginNotProvidedIsSymbol,
  OutsideOfOrderingHours,
  OutsideOfOrderingHoursIsSymbol,
  PaymentError,
  PaymentErrorIsSymbol,
  PaymentMethodNotSupported,
  PaymentMethodNotSupportedIsSymbol,
  ProductItem,
  ProductItemIsSymbol,
  PromotionValidationErrors,
  PromotionValidationErrorsIsSymbol,
  QrWaiterDisabled,
  QrWaiterDisabledIsSymbol,
  RegisteredUserShouldLogIn,
  RegisteredUserShouldLogInIsSymbol,
  RequestedDeliveryTimeTooShort,
  RequestedDeliveryTimeTooShortIsSymbol,
  RestaurantDoesNotExist,
  RestaurantDoesNotExistIsSymbol,
  SmsVerificationRequired,
  SmsVerificationRequiredIsSymbol,
  SoftError,
  SoftErrorIsSymbol,
  Takeaway,
  TakeawayIsSymbol,
  TipsNotAllowed,
  TipsNotAllowedIsSymbol,
  actualValueIsSymbol,
  couponCodesIsSymbol,
  currencyIsSymbol,
  customDeliveryPriceIsSymbol,
  customerIsSymbol,
  decodeCheckoutError,
  decodeCheckoutRequest,
  decodeCustomer,
  decodeFulfillmentMethod,
  decodeItemError,
  decodeMaybe,
  decodeMaybe1,
  decodeOrderSplit,
  decodeProductItem,
  decodeRecordCons1,
  decodeRecordCons4,
  decodeRecordCons5,
  decodeSingleConstructorAr1,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  decodeWithOptionsOther3,
  decodeWithOptionsOther4,
  decodeWithOptionsOther5,
  deliveryAddressIsSymbol,
  differenceIsSymbol,
  draftIsSymbol,
  emailIsSymbol,
  encodeCheckoutError,
  encodeCheckoutRequest,
  encodeCustomer,
  encodeFulfillmentMethod,
  encodeItemError,
  encodeOrderSplit,
  encodeProductItem,
  encodeRecordCons2,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  encodeWithOptionsOther3,
  encodeWithOptionsOther4,
  encodeWithOptionsOther5,
  eq11,
  eq12,
  eq14,
  eq16,
  eq17,
  eq19,
  eq20,
  eq30,
  eq8,
  eqCheckoutError,
  eqCheckoutRequest,
  eqCustomer,
  eqFulfillmentMethod,
  eqItemError,
  eqOrderSplit,
  eqProductItem,
  extraDiscountIsSymbol,
  fieldTestExperimentsIsSymbol,
  fulfillmentMethodIsSymbol,
  fullNameIsSymbol,
  genericCheckoutError,
  genericCheckoutRequest,
  genericCustomer,
  genericDecodeArgsRecord,
  genericEncodeArgsRecord,
  genericFulfillmentMethod,
  genericItemError,
  genericOrderSplit,
  genericProductItem,
  genericShowConstructor1,
  groupIndexIsSymbol,
  hasFieldCheckoutRequest,
  hasFieldCustomer,
  hasFieldOrderSplit,
  hasFieldProductItem,
  isIosReviewModeIsSymbol,
  itemErrorIsSymbol,
  itemsIsSymbol,
  limitIsSymbol,
  localeIsSymbol,
  locationIsSymbol,
  nameIsSymbol,
  newtypeCheckoutRequest_,
  newtypeCustomer_,
  newtypeOrderSplit_,
  newtypeProductItem_,
  noteIsSymbol,
  originIsSymbol,
  packagingContainersIsSymbol,
  paymentMethodIsSymbol,
  phoneIsSymbol,
  productKeyIsSymbol,
  promotionalItemsIsSymbol,
  quantityIsSymbol,
  requestedFulfillmentTimeIsSymbol,
  requestedQuantityIsSymbol,
  restaurantIdIsSymbol,
  showArray,
  showCheckoutError,
  showCheckoutRequest,
  showCustomer,
  showFulfillmentMethod,
  showItemError,
  showMaybe,
  showOrderSplit,
  showProductItem,
  subscribeEmailIsSymbol,
  subscribePhoneIsSymbol,
  subscribeRestaumaticEmailIsSymbol,
  subscribeRestaumaticPhoneIsSymbol,
  subscribedIsSymbol,
  subscribedRestaumaticIsSymbol,
  tipIsSymbol,
  toFillFormTypeCheckoutErr,
  toFillFormTypeCheckoutReq,
  toFillFormTypeCustomer,
  toFillFormTypeFulfillment,
  toFillFormTypeItemError,
  toFillFormTypeOrderSplit,
  toFillFormTypeProductItem,
  unscrambleDecodeCheckoutError,
  unscrambleDecodeCheckoutRequest,
  unscrambleDecodeCustomer,
  unscrambleDecodeFulfillmentMethod,
  unscrambleDecodeItemError,
  unscrambleDecodeOrderSplit,
  unscrambleDecodeProductItem,
  userNoteIsSymbol,
  vatIdIsSymbol,
  waiterPinIsSymbol
};
